const updatesData = [
  { time: '10 分钟前', tag: '突发', title: '某女星工作室凌晨发律师函，否认所有传闻', source: '微博' },
  { time: '25 分钟前', tag: '更新', title: '网红互撕事件新进展：第三方晒出聊天记录实锤', source: '抖音' },
  { time: '1 小时前', tag: '热议', title: '知名导演新片选角引发粉丝大规模抵制', source: '微博' },
  { time: '2 小时前', tag: '爆料', title: '某综艺选手被扒参赛前已有经纪公司签约', source: '小红书' },
  { time: '3 小时前', tag: '追踪', title: '品牌解约事件持续发酵，代言人律师团队介入', source: '微博' },
  { time: '4 小时前', tag: '更新', title: '前乐队成员发文暗示当年解散另有隐情', source: '抖音' },
  { time: '6 小时前', tag: '热议', title: '某选秀节目投票数据异常引发观众质疑', source: '小红书' },
  { time: '8 小时前', tag: '爆料', title: '圈内人士透露某夫妻档综艺邀约费创纪录', source: '微博' },
  { time: '12 小时前', tag: '回顾', title: '上半年十大撕逼事件盘点：哪个最让你意外？', source: '黑料大赛' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">实时快讯</h2>
          <p className="mt-2 text-sm text-foreground-600">按时间倒序排列，最新八卦动态一览无余</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-200"></div>

          <div className="flex flex-col gap-6">
            {updatesData.map((item, i) => (
              <div key={i} className="relative flex items-start gap-5 group cursor-pointer">
                <div className="relative z-10 w-[38px] h-[38px] flex-shrink-0 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-200 group-hover:border-accent-400 group-hover:bg-accent-50 transition-colors duration-200">
                  <span className="w-2.5 h-2.5 rounded-full bg-accent-500"></span>
                </div>
                <div className="flex-1 min-w-0 pb-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">· {item.source}</span>
                  </div>
                  <p className="mt-1.5 text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}